export enum ListVariant {
    Default = "default",
    Square = "square"
}
